import React, { useContext, useEffect, useState } from 'react';
import firebase from 'firebase/compat/app';
import 'firebase/compat/firestore';
import { Usercontext } from '../App';
import styles from './MyOrders.module.css'; // Import the CSS module

export default function MyOrders() {
    const { userdata } = useContext(Usercontext);

    const [myOrder, setMyOrder] = useState([]);
    const [loading, setLoading] = useState(true);

    const getData = async () => {
        if (!userdata) return;

        try {
            console.log("Fetching orders for:", userdata.uid);
            const collection = await firebase.firestore().collection("Orders").get();
            const filteredOrders = collection.docs
                .filter((doc) => doc.data().uid === userdata.uid)
                .map((doc) => ({ id: doc.id, ...doc.data() }));
            setMyOrder(filteredOrders);
        } catch (error) {
            console.error("Error fetching orders:", error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        getData();
    }, [userdata]);

    if (loading) {
        return <h2 className={styles.loadingText}>Loading your orders...</h2>;
    }

    return (
        <div className={styles.pageContainer}>
            {myOrder.length > 0 ? (
                <div className={styles.orderList}>
                    {myOrder.map((order) => (
                        <div className={styles.orderCard} key={order.id}>
                            <div className={styles.cardBody}>
                                <h4 className={styles.cardTitle}>{order.productName}</h4>
                                <h5 className={styles.cardSubtitle}>{order.segment}</h5>
                                <p className={styles.cardText}>{order.address}</p>
                                <h6 className={styles.cardLink}>Price: Rs. {order.price}</h6>
                                <h6 className={styles.cardLink}>Capacity: {order.capacity}</h6>
                            </div>
                        </div>
                    ))}
                </div>
            ) : (
                <h2 className={styles.noOrders}>No Orders Found</h2>
            )}
        </div>
    );
}
